import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import { withRouter, Redirect} from "react-router-dom";
import { AuthContext } from "../Auth";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from "../images/logo text.png" 
import Risk from "../images/risk.png"
import Search from "../images/search.png"
import Logo2 from "../images/logo pic.png" 
import "../App.css"
import "../css/bootstrap.css"
import "../css/styles.css"
import Start from "../images/startEN.png"
import Sugges from "../images/SuggesEN.png"
import form1 from "../images/form1.png"
import form2 from "../images/form2.png"
import form3 from "../images/form3.png"
import form4 from "../images/form4.png"
import form5 from "../images/form5.png"
import form6 from "../images/form6.png"
import form7 from "../images/form7.png"
import form8 from "../images/form8.png"
import form9 from "../images/form9.png"
import form10 from "../images/form10.png"
import form11 from "../images/form11.png"
import form12 from "../images/form12.png"

export const Forms = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [Formstatus, setFormstatus] = useState("");
  const db = app.firestore();
  useEffect (() => {
    const documentRef = db.collection('EIPCAFORM').doc(currentUser.uid);
    documentRef.get().then((doc) => {
      if (doc.exists) {
        let formstatusArray = [];
        formstatusArray.push(doc.data());
        const myStringValue = formstatusArray[0].Form_Result;
        setFormstatus(myStringValue);
        
      } else {
        console.log("No such document!");
        SkipBtn = <p></p>
      }
    }).catch((error) => {
      console.log("Error getting document:", error);
    });
  })

  let SkipBtn;
  let Text;
  if (Formstatus == "No_Risk"){
    SkipBtn = 
    <a className=" " style={{marginLeft: "60%"}} href="/en/Hardware">
       
    </a>
    
  } else if (Formstatus == "Low_Risk") {
    SkipBtn = 
    <a className=" " style={{marginLeft: "60%"}} href="/en/Hardware">
       
    </a>
    
  } else if (Formstatus == "Medium_Risk") {
    SkipBtn = 
    <a className="" style={{marginLeft: "60%"}} href="/en/Hardware">
       
    </a>
    
  } else if (Formstatus == "High_Risk") {
    SkipBtn = 
    <a className=" " style={{marginLeft: "60%"}} href="/en/Hardware">
       
    </a>
    Text =""
  } else {
    SkipBtn = 
    <p></p>
  };
  
  const questions = [
    {
      img: form1,
      question: "Are you women aged more than 55 years or man aged more than 45 years ?",
      answer: "yes",
      page: "1/12"
    },
    {
      img: form2,
      question: "Do you smoke cigarettes or have continuous exposure to secondhand smoke/ quit smoking within a period of no more than 2 years?",
      answer: "yes",
      page: "2/12"
    },
    {
      img: form3,
      question: "Are you Having blood pressure higher than 140/90 millimeters of mercury (mmHg)?",
      answer: "yes",
      page: "3/12"
    },
    {
      img: form4,
      question: "Do you have abnormally high levels of blood lipids (total cholesterol greater than 200 milligrams per deciliter)?",
      answer: "yes",
      page: "4/12"
    },
    {
      img: form5,
      question: "Do you lack physical activity or engage in physical activity less than 3 times per week (30 minutes per session)?",
      answer: "yes",
      page: "5/12"
    },
    {
      img: form6,
      question: "Do you have BMI over 25 kg/m2",
      answer: "yes",
      page: "6/12"
    },
    {
      img: form7,
      question: "Do any direct family members have a history of coronary artery disease?",
      answer: "yes",
      page: "7/12"
    },
    {
      img: form8,
      question: "Do you have diabetes or have blood sugar levels higher than 100 mg/dL?",
      answer: "yes",
      page: "8/12"
    },
    {
      img: form9,
      question: "Are you constantly experiencing a state of chronic stress?",
      answer: "yes",
      page: "9/12"
    },
    {
      img: form10,
      question: "Are you Easily Exhuasted",
      answer: "yes",
      page: "10/12"
    },
    {
      img: form11,
      question: "Do you experience symptoms of chest tightness, chest discomfort, or a sensation of choking or pressure in the chest or throat when exerting yourself?",
      answer: "yes",
      page: "11/12"
    },
    {
      img: form12,
      question: " Do you experience symptoms of palpitations, heart palpitations, dizziness, fainting, or loss of consciousness without a known cause?",
      answer: "yes",
      page: "12/12"
    },
  ];

  const handleAnswer = (answer) => {
    setAnswers([...answers, answer]);
    setCurrentQuestion(currentQuestion + 1);
  };

  const renderQuiz = () => {
    const db = app.firestore();
    const DBref = db.collection("EIPCAFORM").doc(currentUser.uid);
    if (currentQuestion === questions.length) {
      // Quiz completed, show results
      const correctAnswers = answers.filter(
        (answer, index) => answer === questions[index].answer
      );
      let result;
      let resultimg;
      let suggestion;
      let Button;
      let suggestionButton;
      if (correctAnswers.length > 10) {
        result = "You have high Risk!";
        resultimg = "";
        suggestion = "You should seek medical attention as soon as possible.";
        DBref.set({
          "Form_Result" : "High_Risk"
        })
        
      
      } else if (correctAnswers.length > 8) {
        result = "You have a moderate risk of developing heart disease.!";
        resultimg = "";
        suggestion = "You should engage in regular physical exercise and consider having health check-ups at least 2-3 times per year.";
        DBref.set({
          "Form_Result" : "Medium_Risk"
        })
        
       
      } else if (correctAnswers.length > 5) {
        result = "You have a low risk of developing heart disease.!";
        resultimg = "";
        suggestion = "You should start exercising and consider having regular health check-ups at least once a year."
        DBref.set({
          "Form_Result" : "Low_Risk"
        })
        

      } else {
        result = "You have no risk of developing heart disease.";
        resultimg = "";
        suggestion = "You should have regular health check-ups at least once a year."
        DBref.set({
          "Form_Result" : "No_Risk"
        })
        
      }
      console.log(result)

      
      return(
      
      <div>
        <img src={resultimg} style={{width: "10%" , marginTop: "1%" , borderRadius: "10px"}}/>
        <h2 style={{marginTop : "1%" ,padding: "50px", borderRadius: "10px" , marginBottom: "1%"}}  className="bg-gray">{result}<br/>{suggestion}</h2>
        <center>
        <a>{Button}</a>
        <div>{suggestionButton}</div>
        </center>
        <center>
  <div id="jobPanel" className="filter">
    <div className="basic-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Job */}
            <div className="job-container">
              <a style={{textDecoration: "none"}} href="/en/Hardware">
              <img
                className="img6"
                src={Start}
              />
              </a>
            </div>{" "}
            <div className="job-container " >
              <a style={{textDecoration: "none"}} href="/en/SuggestionBad">
              <img
                className="img6"
                src={Sugges}
              />
              </a>
            </div>{" "}
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
      </div>{" "}
      {/* end of container */}
    </div>{" "}
    {/* end of basic-3 */}
  </div>

  </center>
        
        
        
        
      </div>
      
      
      
      );
        

    } else {
      // Show current question
      const question = questions[currentQuestion];
      return (
        
        
        <div style={{marginTop: "20px",padding: "30px", borderRadius: "10px"}} className="bg-gray">
            <div>
             {SkipBtn}
            </div>
          <h2>{question.page}</h2>
          <img style={{marginBottom: "3%" , borderRadius: "10px" , width: "30%"}} src = {question.img}/>
          <h2>{question.question}</h2>
          <button className="mx-3 btn-solid-lg" onClick={() => handleAnswer("yes")}>Yes</button>
          <button className="btn-solid-lg" onClick={() => handleAnswer("no")}>No</button>
        </div>
        
        
        
      );
    }
  };
  



  
  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };

  

// Change file to Field for firestore

  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/en/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              Service <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center>
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              News from EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/about">
              About us
            </Nav.Link>
          </li>
        </center>
        
        
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >Sign out</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/en/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/Form">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/Form">
              EN
            </Nav.Link>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
  <center>  
   {/* Header */}
  <header className="ex-header bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1 my-3">
          <h1>Cardiovascular Disease Risk Assessment Form  </h1>
          <h4>{Text}</h4>
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
    <div>
      
    </div>
    <div>{renderQuiz()}</div>
    
    
</center>

<br/>
<br/>
<br/>
<br/>
      
    </>
  );
};

export default withRouter(Forms);


